import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogoTray from '../LogoTray';
import { clearArticleCacheOnLogin, storeCurrentFilter } from '../../utils/sessionCache';
import './Auth.css';

const API = process.env.REACT_APP_API_URL || '/api';

export default function VerificationLogin() {
  const navigate = useNavigate();
  const request = useRef(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    if (!request.current) {
      const code = new URLSearchParams(window.location.hash.slice(1)).get('code');
      // Remove the short-lived secret from the current history entry immediately.
      window.history.replaceState(window.history.state, '', window.location.pathname);
      request.current = (async () => {
        if (!code) throw new Error('Link za prijavu nije ispravan. Prijavite se lozinkom.');
        const response = await fetch(`${API}/verification-login`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Automatska prijava nije uspjela.');
        await clearArticleCacheOnLogin();
        localStorage.setItem('token', data.token);
        localStorage.setItem('isAdmin', String(data.admin));
        localStorage.setItem('user', JSON.stringify({ username: data.username, admin: data.admin, current_filter: data.current_filter }));
        storeCurrentFilter(data.current_filter);
        await window.jaosveNative?.flushSession();
      })();
    }
    request.current.then(() => { if (active) navigate('/', { replace: true }); })
      .catch(err => { if (active) setError(err.message || 'Prijava nije uspjela. Provjerite vezu i prijavite se lozinkom.'); });
    return () => { active = false; };
  }, [navigate]);
  return <><LogoTray /><div className="auth-container"><div className="auth-box"><div className="auth-content">
    <h2>Potvrda emaila</h2>
    {error ? <><p role="alert">{error}</p><Link to="/login">Prijavi se</Link></> : <p role="status">Email je potvrđen. Prijavljujemo vas…</p>}
  </div></div></div></>;
}
